import { Injectable } from '@angular/core';
import { HttpRequestService } from '../../shared/services/http-request.service';
import { Observable } from 'rxjs';
import { ApiUrlConstants } from '../../shared/constants/api_url_constants';
import { ApiResponse } from '../../shared/common-model/common.model';
import { soScopeMaterialViewModel } from '../../service-order/models/service-order-scop-material.model';
import { acctgAdjustBillingEntryHrsDTO, acctgAdjustBillingEntryCommentDTO, acctgAdjustBillingEntrySOAdditionalItemDTO, acctgAdjustBillingEntrySOEquipmentDTO, acctgAdjustBillingEntrySOMaterialDTO, adjustmentAmountUpdateDTO, billingEntryReportViewModel, billingEntryViewModel, cmPayrollCorrectionRequestViewModel, importantJobUpdatesInfo, payrollEntryAddUpdateDTO, payrollEntryCorrectionCommentAdd, payrollEntryEyeballReportDTO, payrollEntryEyeballReportViewModel, payrollEntryListForReport, payrollEntryReportViewModel, payrollEntryViewModel, payrollEntryWorkerDailyListForReport, acctgAdjustBillingEntryRateDTO, acctgAdjustBillingEntrySupervisionDTO, cmLMLeadManDailyUpdateCheckListReqDTO, cmLMLeadManDailyUpdateCheckListViewModel, billingEntryListViewModel, billingEntryShowListForDropdown, billingEntryDetailsDTO, reportingLeadmanAddUpdateDTO, cmLayoutSlotChangeReqDTO, payrollEntryInitialShowData,manualPayrollEntryDTO,manualPayrollEntryViewModel, manualPayrollEntryAddUpdateDTO } from '../models/job-payroll-entry.model';
import { activeOnUnderOverBudgetJobsViewModel, billingWeekDataForCMDashboard, calendarDataDTO, calendarViewModel, cityListForJobPlanning, cityListForJobPlanningWithDate, dailyActivityBaseInstDismJwDetails, dailyActivityInstDismJWBaseAddUpdateDTO, dailyActivityInstDismOnBudgetAddUpdateDTO, dailyActivityReportInboundInvInstDismJwDetails, dailyReportDataForCMDashboard, jobDailyActivityAddUpdateBaseInvInboundDTO, jobDailyActivityCMOnBudgetReviewedStatusDTO, jobDailyActivityInboundInvViewModel, jobDailyActivityInstDismJwDTO, jobDailyActivityLMSendReportForReview, jobDailyActivityOnBudgetSubContractorDTO, jobDailyActivityReportClientContactDetails, jobDailyActivitySODetailsViewModel, jobLaborAllocationBaseAddUpdateDTO, jobLaborCheckInBaseViewModel, jobLaborCheckInDTO, jobLaborEquipmentsViewModel, jobLaborMaterialsViewModel, jobLaborOverRunResolvedAddDTO, jobLaborPlanTimesheetListViewModel, jobLaborShowDetailsDTO, jobLaborTimesheetUpdateDTO, jobLaborTimesheetViewModel, jobTileListViewModel, laborAllocateWithSlotShowDetails, notifyToLaborDTO, onBudgetComparisonDTO, overRunJobDashboardDataViewModel, payrollWeeksDataForCMDashboard, platinumInstructionCMLMAddUpdateDTO, printDocumentsForShowDTO, showListForJobPlanningViewModel, showListJobPlanningDTO, showUnbillHrsAddUpdateDTO, showUnbillHrsViewModel, todaysCMDashboardInfo } from '../models/job-labor-planning.model';
import { soScopeBoothFieldFilePrint } from '../../service-order/models/service-order-scope-booth.model';
import { HttpClient, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class JobLaborPlanningService {
  constructor(private httpRequestService: HttpRequestService, private http: HttpClient) { }

  getCalendarData(data: calendarDataDTO): Observable<calendarViewModel> {
    return this.httpRequestService.postData<calendarViewModel>(ApiUrlConstants.jobLaborPlanningGetCalendarData, data);
  }
  getCityListForJobPlanning(): Observable<cityListForJobPlanning[]> {
    return this.httpRequestService.getData<cityListForJobPlanning[]>(ApiUrlConstants.jobLaborPlanningGetCityList);
  }
  getShowListForJobPlanning(data: any): Observable<showListForJobPlanningViewModel> {
    return this.httpRequestService.postData<showListForJobPlanningViewModel>(ApiUrlConstants.jobLaborPlanningShowList, data);
  }
  getJobTilesByShowIdAndDate(data: any): Observable<jobTileListViewModel> {
    return this.httpRequestService.postData<jobTileListViewModel>(ApiUrlConstants.jobLaborPlanningGetJobTileList, data);
  }
  jobLaborAllocationAddUpdate(data: jobLaborAllocationBaseAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborAllocationAddUpdate, data);
  }
  jobLaborAllocationDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobLaborAllocationDelete}${id}`);
  }
  jobLaborPlanLeadManUpdate(data: any): Observable<ApiResponse> {
    return this.httpRequestService.patchData<ApiResponse>(ApiUrlConstants.jobLaborPlanLeadManUpdate, data);
  }
  jobLaborPlanUpdateTimeAndMoveDate(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborPlanUpdateTimeAndMoveDate, data);
  }
  jobLaborPlanNotRequiredSlotUpdate(data: any): Observable<ApiResponse> {
    return this.httpRequestService.patchData<ApiResponse>(ApiUrlConstants.jobLaborPlanNotRequiredSlotUpdate, data);
  }
  jobLaborPlanShowUnbillUpdate(data: showUnbillHrsAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborPlanShowUnbillUpdate, data);
  }
  jobLaborPlanShowUnbillAdd(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborPlanShowUnbillAdd, data);
  }
  getAllUnbillHrsByShowId(id: any): Observable<showUnbillHrsViewModel[]> {
    return this.httpRequestService.getData<showUnbillHrsViewModel[]>(`${ApiUrlConstants.jobLaborPlanGetAllUnbillHrsByShowId}${id}`);
  }
  deleteJobLaborPlanUnbillHrs(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobLaborPlanUnbillHrsDelete}${id}`);
  }
  // downloadExcelFileData(data: any): Observable<any> {
  //   return this.httpRequestService.postFileData(ApiUrlConstants.jobLaborPlanAllocExcelDataByShowId, data);
  // }
  downloadExcelFileData(obj: any): Observable<HttpResponse<Blob>> {
  return this.http.post(
    ApiUrlConstants.jobLaborPlanAllocExcelDataByShowId,   // keep your real URL
    obj,
    { observe: 'response', responseType: 'blob' }
  );
}
  getOverRunJobDataForDashboard(id: string): Observable<overRunJobDashboardDataViewModel> {
    return this.httpRequestService.getData<overRunJobDashboardDataViewModel>(`${ApiUrlConstants.jobLaborOverRunJobDashboardData}${id}`);
  }
  getAllOnUnderOverActiveJobsForCM(cityId: string): Observable<activeOnUnderOverBudgetJobsViewModel[]> {
    return this.httpRequestService.getData<activeOnUnderOverBudgetJobsViewModel[]>(`${ApiUrlConstants.jobLaborGetOnUnderOverBudgetJobs}${cityId}`);
  }
  jobLaborOverRunJobResolved(data: jobLaborOverRunResolvedAddDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborOverRunJobResolved, data);
  }
  getCheckInDataByShowAndDate(data: jobLaborShowDetailsDTO): Observable<jobLaborCheckInBaseViewModel> {
    return this.httpRequestService.postData<jobLaborCheckInBaseViewModel>(ApiUrlConstants.jobLaborCheckInGetData, data);
  }
  jobLaborCheckInUpdate(data: jobLaborCheckInDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborCheckInUpdate, data);
  }
  getAssignedShowListForCityManager(data: showListJobPlanningDTO): Observable<showListForJobPlanningViewModel> {
    return this.httpRequestService.postData<showListForJobPlanningViewModel>(ApiUrlConstants.jobLaborPlanAssignedShowListForCityManager, data);
  }

  getAllCityListForAssignedUser(): Observable<cityListForJobPlanningWithDate> {
    return this.httpRequestService.getData<cityListForJobPlanningWithDate>(ApiUrlConstants.jobLaborPlanningGetAllAssinedCityList);
  }
  getAllCityListForCheckIn(): Observable<cityListForJobPlanningWithDate> {
    return this.httpRequestService.getData<cityListForJobPlanningWithDate>(ApiUrlConstants.jobLaborPlanningGetAllAssinedCityList);
  }
  getJobLaborDailyActivitiesByCityShowAndDate(data: any): Observable<jobLaborPlanTimesheetListViewModel[]> {
    return this.httpRequestService.postData<jobLaborPlanTimesheetListViewModel[]>(ApiUrlConstants.jobLaborDailyActivitiesGetAll, data);
  }
  getJobLaborTimeSheetBySOAndDate(data: any): Observable<jobLaborTimesheetViewModel> {
    return this.httpRequestService.postData<jobLaborTimesheetViewModel>(ApiUrlConstants.jobLaborGetTimesheetBySOAndDate, data);
  }
  updateJobLaborTimesheet(data: jobLaborTimesheetUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborUpdateTimesheet, data);
  }
  jobLaborMaterialCustomDeleteForCMLM(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobLaborSoScopeMaterialDeleteForCMLM}${id}`);
  }

  jobLaborMaterialAddUpdateForCMLM(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborSoScopeMaterialUpdateForCMLM, data);
  }
  getAllJobLaborSoScopeMaterialsCMLM(id: any): Observable<jobLaborMaterialsViewModel> {
    return this.httpRequestService.getData<jobLaborMaterialsViewModel>(`${ApiUrlConstants.jobLaborGetAllSoScopeMaterialsForCMLM}${id}`);
  }
  getAllJobLaborSoScopeEquipmentCMLM(id: any): Observable<jobLaborEquipmentsViewModel> {
    return this.httpRequestService.getData<jobLaborEquipmentsViewModel>(`${ApiUrlConstants.jobLaborGetAllSoScopeEquipmentForCMLM}${id}`);
  }

  jobLaborEquipmentCustomDeleteForCMLM(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobLaborSoScopeEquipmentDeleteForCMLM}${id}`);
  }
  jobLaborEquipmentAddUpdateForCMLM(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborSoScopeEquipmentAddUpdateForCMLM, data);
  }

  jobDailyActivityInboundInvAddUpdate(data: jobDailyActivityAddUpdateBaseInvInboundDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityInboundInvAddUpdate, data);
  }
  getJobDailyActivityInboundInvDetails(data: any): Observable<jobDailyActivityInboundInvViewModel> {
    return this.httpRequestService.postData<jobDailyActivityInboundInvViewModel>(ApiUrlConstants.jobDailyActivityGetInboundInvDetails, data);
  }
  getJobDailyActivitySODetails(data: any): Observable<jobDailyActivitySODetailsViewModel> {
    return this.httpRequestService.postData<jobDailyActivitySODetailsViewModel>(ApiUrlConstants.jobDailyActivitySODetails, data);
  }
  jobDailyActivityGetInboundInvFileUpload(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityGetInboundInvFileUpload, data);
  }
  jobDailyActivityInboundInvFileDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobDailyActivityInboundInvFileDelete}${id}`);
  }
  jobDailyActivityInboundInvFileDownload(id: any): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.jobDailyActivityInboundInvFileDownload}${id}`);
  }
  jobDailyActivityInstDismJWAddUpdate(data: dailyActivityInstDismJWBaseAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityInstDismJwCategoryAddUpdate, data);
  }
  jobDailyActivityInstDismOnBudgetAddUpdate(data: dailyActivityInstDismOnBudgetAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityInstDismOnBudgetCategoryAddUpdate, data);
  }
  getJobDailyActivityInstDismJWDetails(data: jobDailyActivityInstDismJwDTO): Observable<dailyActivityBaseInstDismJwDetails> {
    return this.httpRequestService.postData<dailyActivityBaseInstDismJwDetails>(ApiUrlConstants.jobDailyActivityInstDismJwDetails, data);
  }
  jobDailyActivityInstDismJwFileUpload(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityInstDismJwFileUpload, data);
  }
  jobDailyActivityInstDismJwForOnBudgetSubContractor(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityInstDismJwForOnBudgetSubContractor, data);
  }
  jobDailyActivityInstDismJwFileDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobDailyActivityInstDismJwFileDelete}${id}`);
  }
  jobDailyActivityInstDismDeleteOnBudgetSubContractor(data: jobDailyActivityOnBudgetSubContractorDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityInstDismDeleteOnBudgetSubContractor, data);
  }
  jobDailyActivityInstDismJwFileDownload(id: any): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.jobDailyActivityInstDismJWFileDownload}${id}`);
  }
  getLaborAllocatedDetailsByIdAndDate(data: any): Observable<laborAllocateWithSlotShowDetails[]> {
    return this.httpRequestService.postData<laborAllocateWithSlotShowDetails[]>(ApiUrlConstants.jobLaborPlanGetLaborAllocatedDetailsByIdAndDate, data);
  }
  getLaborAllocatedDetailsByIdAndDateList(data: any): Observable<laborAllocateWithSlotShowDetails[]> {
    return this.httpRequestService.postData<laborAllocateWithSlotShowDetails[]>(ApiUrlConstants.jobLaborPlanGetLaborAllocatedDetailsByIdAndDateList, data);
  }
  getJobDailyActivityInboundInvInstDismJwDetails(id: string): Observable<dailyActivityReportInboundInvInstDismJwDetails> {
    return this.httpRequestService.getData<dailyActivityReportInboundInvInstDismJwDetails>(`${ApiUrlConstants.jobDailyActivityInboundInvInstDismJwDetails}${id}`);
  }
  jobDailyActivityReportDownload(id: any): Observable<any> {
    return this.httpRequestService.getFileData(`${ApiUrlConstants.jobDailyActivityReportDownload}${id}`);
  }
  jobDailyActivityGetClientContacts(data: any): Observable<jobDailyActivityReportClientContactDetails> {
    return this.httpRequestService.postData<jobDailyActivityReportClientContactDetails>(ApiUrlConstants.jobDailyActivityGetClientContacts, data);
  }
  jobDailyActivityCompleteAndSend(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityCompleteAndSend, data);
  }

  jobDailyActivityReportMarkComplete(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityReportMarkAsComplete, data);
  }
  getPayrollEntryByWeek(data: any): Observable<payrollEntryViewModel[]> {
    return this.httpRequestService.postData<payrollEntryViewModel[]>(ApiUrlConstants.jobPayrollEntryGetByWeek, data);
  }
  getManualPayrollEntryByWeek(data: any): Observable<manualPayrollEntryViewModel[]>{
    return this.httpRequestService.postData<manualPayrollEntryViewModel[]>(ApiUrlConstants.jobManualPayrollEntryGetByWeek, data);
  }
  getManualPayrollEntryById(id: string): Observable<manualPayrollEntryViewModel> {
    return this.httpRequestService.getData<manualPayrollEntryViewModel>(`${ApiUrlConstants.jobManualPayrollEntryGetById}/${id}`);
}
  manualPayrollEntryAdd(data: manualPayrollEntryAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobManualPayrollEntryAdd, data);
  }
  manualPayrollEntryUpdate(data: manualPayrollEntryAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobManualPayrollEntryUpdate, data);
  }
  manualPayrollEntryDelete( data: { manualPayrollEntryId: string }): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobManualPayrollEntryDelete, data);
}
  getPayrollEntryInitialShowList(data: any): Observable<payrollEntryInitialShowData[]> {
    return this.httpRequestService.postData<payrollEntryInitialShowData[]>(ApiUrlConstants.jobPayrollEntryInititalShowListGetByWeek, data);
  }
  jobPayrollEntryAddUpdate(data: payrollEntryAddUpdateDTO[]): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobPayrollEntryAddUpdate, data);
  }
  jobPayrollEntrySubmit(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobPayrollEntrySubmit, data);
  }
  jobPayrollEntryRequestForCorrection(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.jobPayrollEntryRequestForCorrection}${id}`, "");
  }
  getBillingEntry(data: any): Observable<billingEntryListViewModel[]> {
    return this.httpRequestService.postData<billingEntryListViewModel[]>(ApiUrlConstants.jobBillingEntryGetList, data);
  }
  getBillingEntryList(data: any): Observable<billingEntryViewModel[]> {
    return this.httpRequestService.postData<billingEntryViewModel[]>(ApiUrlConstants.jobBillingEntryGetList, data);
  }
  getShowListForBillingEntryByCityId(cityId: any): Observable<billingEntryShowListForDropdown[]> {
    return this.httpRequestService.getData<billingEntryShowListForDropdown[]>(`${ApiUrlConstants.jobShowListforBillingEntryByCityId}${cityId}`);
  }
  getBillingEntryGetDetailsByShowId(data: billingEntryDetailsDTO): Observable<billingEntryViewModel> {
    return this.httpRequestService.postData<billingEntryViewModel>(ApiUrlConstants.jobBillingEntryGetDetailsByShowId, data);
  }
  billingEntryMasterAddUpdate(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryMasterAddUpdate, data);
  }
  billingEntryAddUpdate(data: any): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAddUpdate, data);
  }
  billingEntryBlindCallDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobBillingEntryBlindCallDelete}${id}`);
  }
  billingEntrySubmitSO(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.jobBillingEntrySubmitSO}${id}`, "");
  }
  billingEntrySubmitShow(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.jobBillingEntrySubmitShow}${id}`, "");
  }
  getPayrollEntryReport(data: any): Observable<payrollEntryReportViewModel[]> {
    return this.httpRequestService.postData<payrollEntryReportViewModel[]>(ApiUrlConstants.jobPayrollEntryReportGet, data);
  }
  getPayrollEntryCorrectionReport(data: any): Observable<payrollEntryListForReport[]> {
    return this.httpRequestService.postData<payrollEntryListForReport[]>(ApiUrlConstants.jobPayrollEntryCorrectionReportGet, data);
  }
  getPayrollEntrySnapshot(data: any): Observable<payrollEntryListForReport[]> {
    return this.httpRequestService.postData<payrollEntryListForReport[]>(ApiUrlConstants.jobPayrollEntrySnapshotGet, data);
  }
  getBillingEntryReport(data: any): Observable<billingEntryReportViewModel[]> {
    return this.httpRequestService.postData<billingEntryReportViewModel[]>(ApiUrlConstants.jobBillingEntryReportGet, data);
  }
  getBillingEntryReportView(id: any): Observable<any> {
    return this.httpRequestService.getData(`${ApiUrlConstants.jobBillingEntryReportViewGet}${id}`);
  }
  getBillingEntryReportDetails(id: any): Observable<any> {
    return this.httpRequestService.getData(`${ApiUrlConstants.jobBillingEntryReportDetailsGet}${id}`);
  }
  getTodayCardDashbaordData(id: string): Observable<todaysCMDashboardInfo> {
    return this.httpRequestService.getData<todaysCMDashboardInfo>(`${ApiUrlConstants.jobLaborTodaysCardData}${id}`);
  }
  getPayrollEntryCurrentWeekData(id: string): Observable<payrollWeeksDataForCMDashboard> {
    return this.httpRequestService.getData<payrollWeeksDataForCMDashboard>(`${ApiUrlConstants.jobLaborPayrollEntryCurrentData}${id}`);
  }
  getBillingEntryCurrentWeekData(id: string): Observable<billingWeekDataForCMDashboard> {
    return this.httpRequestService.getData<billingWeekDataForCMDashboard>(`${ApiUrlConstants.jobLaborBillingEntryCurrentData}${id}`);
  }
  getDailyReportDataForCMDashboard(id: string): Observable<dailyReportDataForCMDashboard> {
    return this.httpRequestService.getData<dailyReportDataForCMDashboard>(`${ApiUrlConstants.jobLaborDailyReportData}${id}`);
  }
  getImportantJobUpdates(id: string): Observable<importantJobUpdatesInfo> {
    return this.httpRequestService.getData<importantJobUpdatesInfo>(`${ApiUrlConstants.jobLaborGetImportantJobUpdates}${id}`);
  }
  importantJobUpdatesClear(): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborImportantJobUpdateClear, null);
  }
  approvePayrollEntryCorrectionReqByAccounting(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingApprovePayrollEntryCorrection}${id}`, "");
  }
  getPayrollEntryCorrectionEyeballReport(data: payrollEntryEyeballReportDTO): Observable<payrollEntryEyeballReportViewModel> {
    return this.httpRequestService.postData<payrollEntryEyeballReportViewModel>(ApiUrlConstants.jobPayrollEntryCorrectionEyeballReportGet, data);
  }
  payrollEntryAddCorrectionCommentByAcct(data: payrollEntryCorrectionCommentAdd): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.accountingAddPayrollEntryCorrectionComment, data);
  }
  markSOAsReviewedByAccounting(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingMarkSOAsReviewed}${id}`, "");
  }
  jobBillingEntryUpdateAdjustmentAmount(data: adjustmentAmountUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryUpdateAdjustmentAmount, data);
  }
  markSOAsPayrollCompleteByAccounting(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingMarkSOPayrollComplete}${id}`, "");
  }
  markShowAsPayrollCompleteByAccounting(id: string): Observable<ApiResponse> {
    return this.httpRequestService.putData<ApiResponse>(`${ApiUrlConstants.accountingMarkShowPayrollComplete}${id}`, "");
  }
  platinumInstructionAnsByCMLM(data: platinumInstructionCMLMAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityPlatinumInstructionAnsByCMLM, data);
  }
  getPayrollCorrectionLastWeek(id: string): Observable<cmPayrollCorrectionRequestViewModel[]> {
    return this.httpRequestService.getData<cmPayrollCorrectionRequestViewModel[]>(`${ApiUrlConstants.jobLaborGetPayrollCorrectionLastWeek}${id}`);
  }
  acctgAdjustBillingEntrySTOTDTHrs(data: acctgAdjustBillingEntryHrsDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustSTOTDTHrs, data);
  }
  acctgAdjustBillingEntrySTOTDTComment(data: acctgAdjustBillingEntryCommentDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustSTOTDTComment, data);
  }
  acctgAdjustBillingEntryMaterial(data: acctgAdjustBillingEntrySOMaterialDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustMaterial, data);
  }
  acctgAdjustBillingEntryEquipment(data: acctgAdjustBillingEntrySOEquipmentDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustEquipment, data);
  }
  acctgAdjustBillingEntryAdditionalItem(data: acctgAdjustBillingEntrySOAdditionalItemDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustAdditionalItem, data);
  }
  acctgAdjustBillingEntrySTOTDTRate(data: acctgAdjustBillingEntryRateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustSTOTDTRate, data);
  }
  acctgAdjustBillingEntrySupvPerc(data: acctgAdjustBillingEntrySupervisionDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobBillingEntryAcctgAdjustSupervPercUpdate, data);
  }
  acctgAdjustBillingEntryMaterialDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobBillingEntryAcctgAdjustMaterialDelete}${id}`);
  }
  acctgAdjustBillingEntryEquipmentDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobBillingEntryAcctgAdjustEquipmentDelete}${id}`);
  }
  acctgAdjustBillingEntryAdditionalItemDelete(id: any): Observable<ApiResponse> {
    return this.httpRequestService.deleteData<ApiResponse>(`${ApiUrlConstants.jobBillingEntryAcctgAdjustAdditionalItemDelete}${id}`);
  }
  jobDailyActivityGetCMLeadManDailyCheckListUpdate(data: cmLMLeadManDailyUpdateCheckListReqDTO): Observable<cmLMLeadManDailyUpdateCheckListViewModel> {
    return this.httpRequestService.postData<cmLMLeadManDailyUpdateCheckListViewModel>(ApiUrlConstants.jobDailyActivityGetCMLeadManDailyCheckListUpdate, data);
  }
  reportingLeadmanAddUpdate(data: reportingLeadmanAddUpdateDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborPlanningReportingLeadmanAddUpdate, data);
  }
  notifyAllLabor(data: notifyToLaborDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborPlanningNotifyToAllLabor, data);
  }
  payrollEntryCMLayoutChangeRequestUpdate(data: cmLayoutSlotChangeReqDTO): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobPayrollEntryCMLayoutChangeRequest, data);
  }
  cmOnBudgetMarkReviewedStatusUpdate(data: jobDailyActivityCMOnBudgetReviewedStatusDTO[]): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobLaborCMOnBudgetMarkReviewedStatusUpdate, data);
  }
  lmSendDailyReportToCMReviewedByCM(data: jobDailyActivityLMSendReportForReview): Observable<ApiResponse> {
    return this.httpRequestService.postData<ApiResponse>(ApiUrlConstants.jobDailyActivityLMSendReportToCMReviewedByCM, data);
  }
  getOnBudgetComparison(data: onBudgetComparisonDTO): Observable<jobLaborPlanTimesheetListViewModel> {
    return this.httpRequestService.postData<jobLaborPlanTimesheetListViewModel>(ApiUrlConstants.jobDailyActivityGetOnBudgetComparison, data);
  }

}
